import React from 'react';
import style from './RanksModal.module.css';
import Modal from '../Modal/Modal';
import Rank from '../Rank/Rank';

const RanksModal = ({ onClose, ranks, currentXP = 0 }) => {
	const getCurrentRankIndex = () => {
		for (let i = ranks.length - 1; i >= 0; i--) {
			if (currentXP >= ranks[i].minScore) return i;
		}
		return 0;
	};

	const currentRankIdx = getCurrentRankIndex();

	return (
		<Modal
			onClose={onClose}
			title='Rank Progression'
			subtitle='Track your growth and unlock stronger tiers as you earn XP.'
			maxWidth={760}
			headerRight={<span className={style.CurrentXPBadge}>{currentXP.toLocaleString()} XP</span>}
		>
			<div className={style.RanksWrapper}>
				{ranks.map((rank, i) => (
					<Rank
						key={rank.rank}
						name={rank.rank}
						emoji={rank.emoji}
						minScore={rank.minScore}
						maxScore={rank.maxScore}
						vibe={rank.vibe}
						isCurrentRank={i === currentRankIdx}
					/>
				))}
			</div>
		</Modal>
	);
};

export default RanksModal;
